import { isStoredSessionStarted } from '@/lib/session'
import { authUser } from '@/api/user'

const state = {
  started: false
}

const actions = {
  async start ({ commit, dispatch }) {
    const hasStored = isStoredSessionStarted()
    if (!hasStored) {
      dispatch('session/clean', null, { root: true })
    } else {
      try {
        const {
          admin,
          name,
          tags,
          systemmodules,
          usertype
        } = await authUser()

        dispatch('session/setSession', {
          admin,
          name,
          tags,
          systemmodules,
          usertype
        }, { root: true })
      } catch (e) {
        dispatch('session/clean', {}, { root: true })
      }
    }
    commit('setStarted')
  }
}

const mutations = {
  setStarted (state) {
    state.started = true
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
